export default{
    company: {
        index: 'company-index',
    }
}
